/** Bearbeitungs-Templates der Bestellpositions-View — Port von `IwmEditColumnsBestellposition.razor`. */

import { ContainerSidebarTrigger } from '@/components/inputs/ContainerSidebarTrigger';
import type { OrderPosition } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

import type { CellRenderer, CellTemplateMap } from '../types';
import { ContainerIdEditor } from './ContainerIdEditor';
import { CONTAINER_SIDEBAR_FIELDS } from './containerSidebarFields';
import { GruppenkennzeichenEditor } from './GruppenkennzeichenEditor';

function gruppenkennzeichen(field: 'Forwarder' | 'ShippingStatus'): CellRenderer<OrderPosition> {
  return (model) => (
    <GruppenkennzeichenEditor
      value={model[field]}
      entity={EntityTypes.Bestellposition}
      fieldName={field}
      onCommit={(value) => {
        model[field] = value;
      }}
    />
  );
}

const sidebarTemplates: CellTemplateMap<OrderPosition> = Object.fromEntries(
  CONTAINER_SIDEBAR_FIELDS.map((field): [string, CellRenderer<OrderPosition>] => [
    field,
    (model) => <ContainerSidebarTrigger containerId={model.ContainerId ?? 0} />,
  ]),
);

export const orderPositionEditTemplates: CellTemplateMap<OrderPosition> = {
  Forwarder: gruppenkennzeichen('Forwarder'),
  ShippingStatus: gruppenkennzeichen('ShippingStatus'),
  ContainerId: (model) => <ContainerIdEditor model={model} />,
  ...sidebarTemplates,
};

export default orderPositionEditTemplates;
